module.exports = __webpack_public_path__ + "static/img/topbg-on.90a18d98.png";